<template>
    <div class="app-container">
        <div class="filter-container">
            <el-input clearable style="width: 200px;" class="filter-item" placeholder="类别" v-model="listQuery.category">
            </el-input>
            <el-input clearable style="width: 200px;" class="filter-item" placeholder="名称" v-model="listQuery.name">
            </el-input>
            <el-select style="width: 150px" class="filter-item" v-model="listQuery.status">
                <el-option label="全部状态" :value="99">
                </el-option>
                <el-option label="正常" :value="0">
                </el-option>
                <el-option label="冻结" :value="-1">
                </el-option>
            </el-select>

            <el-button class="filter-item" type="info" icon="el-icon-search" @click="doSearch">搜索</el-button>
            <el-button class="filter-item" icon="el-icon-refresh" @click="doReset">重置</el-button>
            <el-button class="filter-item" icon="el-icon-refresh" @click="doRefreshCache">刷新缓存</el-button>
            <el-button class="filter-item" type="primary" icon="el-icon-plus" @click='showAddDialog'>添加</el-button>

        </div>
        <el-table :data="list" v-loading="listLoading" fit border highlight-current-row style="width: 100%" max-height="600">
            <el-table-column align="left" label="类别" width="220">
                <template slot-scope="scope">
                    <span>{{scope.row.category}}</span>
                </template>
            </el-table-column>
            <el-table-column align="left" label="名称" width="180">
                <template slot-scope="scope">
                    <span>{{scope.row.dataName}}</span>
                </template>
            </el-table-column>
            <el-table-column align="left" label="说明" width="200">
                <template slot-scope="scope">
                    <span>{{scope.row.remark}}</span>
                </template>
            </el-table-column>
            <el-table-column align="left" label="数值" width="70">
                <template slot-scope="scope">
                    <span>{{scope.row.dataValue}}</span>
                </template>
            </el-table-column>
            <el-table-column align="left" label="显示">
                <template slot-scope="scope">
                    <span>{{scope.row.dataDisplay}}</span>
                </template>
            </el-table-column>
            <el-table-column align="left" label="排序" width="70">
                <template slot-scope="scope">
                    <span>{{scope.row.sort}}</span>
                </template>
            </el-table-column>

            <el-table-column class-name="status-col" align="center" label="状态" width="110">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status | statusFilter">{{scope.row.status | statusDisplay}}</el-tag>
                </template>
            </el-table-column>

            <el-table-column align="center" label="操作" width="150" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini"  @click="showEditDialog(scope.row)">编辑</el-button>
                    <el-button type="warning" size="mini" @click="toDelete(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <el-dialog title="添加数据" :visible.sync="newDialogVisible" width="30%">
            <el-form ref="newForm" :model="newData" :rules="newFormRules" label-position="right" label-width="120px">
                <el-form-item label="类别" prop="category">
                    <el-input style="width: 200px" v-model="newData.category"></el-input>
                </el-form-item>
                <el-form-item label="名称" prop="dataName">
                    <el-input style="width: 200px" v-model="newData.dataName"></el-input>
                </el-form-item>
                <el-form-item label="数值">
                    <el-input-number style="width: 120px" v-model="newData.dataValue"></el-input-number>
                </el-form-item>
                <el-form-item label="显示">
                    <el-input style="width: 200px" v-model="newData.dataDisplay"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number style="width: 120px" v-model="newData.sort" :min="1"></el-input-number>
                </el-form-item>
                <el-form-item label="说明">
                    <el-input type="textarea" style="width: 200px" v-model="newData.remark"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
          <el-button @click="newDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="doAddUser">确定</el-button>
        </span>
        </el-dialog>

        <el-dialog title="编辑数据" :visible.sync="editDialogVisible" width="30%">
            <el-form ref="editForm" :model="editData" :rules="newFormRules" label-position="right" label-width="120px">
                <el-form-item label="类别" prop="category">
                    <el-input style="width: 200px" v-model="editData.category"></el-input>
                </el-form-item>
                <el-form-item label="名称" prop="dataName">
                    <el-input style="width: 200px" v-model="editData.dataName"></el-input>
                </el-form-item>
                <el-form-item label="数值">
                    <el-input-number style="width: 120px" v-model="editData.dataValue"></el-input-number>
                </el-form-item>
                <el-form-item label="显示">
                    <el-input style="width: 200px" v-model="editData.dataDisplay"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number style="width: 120px" v-model="editData.sort" :min="1"></el-input-number>
                </el-form-item>
                <el-form-item label="说明">
                    <el-input type="textarea" style="width: 200px" v-model="editData.remark"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select style="width: 200px" class="filter-item" v-model="editData.status">
                        <el-option label="正常" :value="0">
                        </el-option>
                        <el-option label="冻结" :value="-1">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="doUpdate">确定</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
import store from '@/store'

export default {
    name: 'SystemDictionaryList',
    data() {
        return {
            list: null,
            total: 0,
            listLoading: false,
            listQuery: {
                page: 1,
                limit: 10,
                category: "",
                name: "",
                status: 99,
                role: 99,
            },
            roles: [],

            newDialogVisible: false,
            newData: {
                category: "",
                dataName: "",
                dataValue: 0,
                dataDisplay: "",
                sort: 0,
                remark: "",
            },

            editDialogVisible: false,
            editData: {
                id: 0,
                category: "",
                dataName: "",
                dataValue: 0,
                dataDisplay: "",
                sort: 0,
                remark: "",
                status: 0,
            },

            newFormRules: {
                category: [{
                    required: true,
                    message: '请输入类别名',
                    trigger: 'blur'
                }, {
                    min: 4,
                    max: 50,
                    message: '长度应在4-50位',
                    trigger: 'blur'
                }],
                dataName: [{
                    required: true,
                    message: '请输入名称',
                    trigger: 'blur'
                }, {
                    min: 1,
                    max: 20,
                    message: '长度应在1-20位',
                    trigger: 'blur'
                }],
            }
        };
    },
    filters: {
        statusFilter(status) {
            const statusMap = {
                0: "success",
                1: "info"
            };
            return statusMap[status];
        },
        statusDisplay(status) {
            const statusMap = {
                "0": "正常",
                "-1": "冻结"
            };
            return statusMap[status];
        },
    },
    beforeRouteEnter(to, from, next) {
        next();
    },
    activated() {
        if (this.$route.meta.hasOwnProperty("redraw") && this.$route.meta.redraw) {
            this.doReset();
            this.$route.meta.redraw = false;
        }
        if (this.$route.meta.hasOwnProperty("refresh") && this.$route.meta.refresh) {
            this.getList();
            this.$route.meta.refresh = false;
        }
    },
    created() {
        this.doReset();
    },
    methods: {
        doReset() {
            this.list = null;
            this.total = 0;
            this.listLoading = true;
            this.listQuery = {
                page: 1,
                limit: 10,
                category: "",
                name: "",
                status: 99,
                role: 99,
            };
            this.doSearch();
        },
        doSearch() {
            this.listQuery.page = 1
            this.getList();
        },
        getList() {
            this.listLoading = true;
            var parent = this;
            this.$httpAuth
                .post("/v1/backendDictionaryRpc/list", {
                    pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
                    pageCount: this.listQuery.limit,
                    status: this.listQuery.status,
                    category: this.listQuery.category,
                    name: this.listQuery.name,
                })
                .then(function (response) {
                    parent.listLoading = false;
                    parent.list = response.data.data;
                    parent.total = response.data.total;
                })
                .catch(() => {
                    parent.listLoading = false;
                });
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        toDelete(id) {
            this.$confirm('是否删除该数据?', '提示', {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var parent = this;
                this.$httpAuth
                    .post("/v1/backendDictionaryRpc/delete", {
                        id: id
                    })
                    .then(function (response) {
                        parent.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        parent.getList()
                    })

            })
        },
        showAddDialog() {
            this.newDialogVisible = true;
            this.newData = {
                category: "",
                dataName: "",
                dataValue: 0,
                dataDisplay: "",
                sort: 0,
                remark: "",
            }
            if (this.$refs['newForm']) {
                this.$refs['newForm'].resetFields();
            }
        },
        doAddUser() {
            this.$refs['newForm'].validate((valid) => {
                if (valid) {
                    var parent = this
                    this.$httpAuth
                        .post("/v1/backendDictionaryRpc/add", {
                            "category": this.newData.category,
                            "dataName": this.newData.dataName,
                            "dataValue": this.newData.dataValue,
                            "dataDisplay": this.newData.dataDisplay,
                            "sort": this.newData.sort,
                            "remark": this.newData.remark,
                        })
                        .then(function (response) {
                            parent.getList()
                            parent.newDialogVisible = false;
                        })
                }
            });

        },
        showEditDialog(row) {
            this.editData = {
                id: row.id,
                category: row.category,
                dataName: row.dataName,
                dataValue: row.dataValue,
                dataDisplay: row.dataDisplay,
                sort: row.sort,
                remark: row.remark,
                status: row.status,
            }
            this.editDialogVisible = true;
            if (this.$refs['editForm']) {
                this.$refs['editForm'].resetFields();
            }
        },
        doUpdate() {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    var parent = this
                    this.$httpAuth
                        .post("/v1/backendDictionaryRpc/update", {
                            "id": this.editData.id,
                            "category": this.editData.category,
                            "dataName": this.editData.dataName,
                            "dataValue": this.editData.dataValue,
                            "dataDisplay": this.editData.dataDisplay,
                            "sort": this.editData.sort,
                            "remark": this.editData.remark,
                            "status": this.editData.status,
                        })
                        .then(function (response) {
                            parent.getList()
                            parent.editDialogVisible = false;
                        })
                }
            });
        },
        doRefreshCache() {
            var parent = this
            this.$httpAuth
                .post("/v1/backendDictionaryRpc/refreshCache", {
                    
                })
                .then(function (response) {
                    parent.$message({
                            message: '刷新缓存成功',
                            type: 'success'
                        });
                })
        }

    }
};
</script>

<style scoped>
.edit-input {
    padding-right: 100px;
}

.cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
}
</style>
